

export function reFloat(v: number, length: number = 8) {
    return parseFloat(v.toFixed(length));
}

export function renderBool(s: any) {
    return s ? "√" : "x";
}